/**
 * The classes of § Primitives, Link, apart from the component so the public entry's own link
 * (`apps/web/src/public/router.tsx`) draws the same link without the authenticated router, which the
 * public bundle's budget keeps out (FR-015-080). A plain string join, because `cn` would bring
 * tailwind-merge into that bundle for two fixed class sets.
 */
export type LinkVariant = "inline" | "standalone";

const BASE = "rounded-sm text-accent-text decoration-(length:--border-width) underline-offset-(--space-1) hover:underline";
const VARIANTS: Readonly<Record<LinkVariant, string>> = {
  inline: "underline",
  standalone: "no-underline font-semibold",
};

export function linkClassName(variant: LinkVariant, className?: string): string {
  return className === undefined ? `${BASE} ${VARIANTS[variant]}` : `${BASE} ${VARIANTS[variant]} ${className}`;
}
